(() => {
  if (window.bytekorPointerReady) return;
  window.bytekorPointerReady = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const selector = '.pk-button,.pk-hero-object,.pk-product-art,.pk-card-image,.pk-newsletter-form,.pk-faq details,.pk-landing-feature--visual figure,.pk-detail-visual';
  let active = null;
  function clear() {
    if (!active) return;
    active.classList.remove('pk-pointer-active');
    active.style.removeProperty('--pk-dx');
    active.style.removeProperty('--pk-dy');
    active.style.removeProperty('--pk-tilt-x');
    active.style.removeProperty('--pk-tilt-y');
    active = null;
  }
  document.addEventListener('pointermove', event => {
    if (event.pointerType === 'touch' || !fine.matches || motion.matches) return clear();
    const target = event.target.closest(selector);
    if (active !== target) { clear(); active = target; }
    if (!target) return;
    const box = target.getBoundingClientRect();
    const x = event.clientX - box.left, y = event.clientY - box.top;
    target.style.setProperty('--pk-x', `${x}px`);
    target.style.setProperty('--pk-y', `${y}px`);
    if (target.classList.contains('pk-product-art')) {
      target.style.setProperty('--pk-tilt-x', `${-(y/box.height-.5)*9}deg`);
      target.style.setProperty('--pk-tilt-y', `${(x/box.width-.5)*12}deg`);
    }
    if (target.classList.contains('pk-button') && !target.disabled) {
      target.style.setProperty('--pk-dx', `${Math.max(-4,Math.min(4,(x-box.width/2)*.035))}px`);
      target.style.setProperty('--pk-dy', `${Math.max(-3,Math.min(3,(y-box.height/2)*.06))}px`);
    }
    target.classList.add('pk-pointer-active');
  }, {passive:true});
  document.addEventListener('pointerleave', clear);
  window.addEventListener('scroll', clear, {passive:true});
  window.addEventListener('blur', clear);
  motion.addEventListener('change', clear);
})();
